interface PrimarySenderInfo {
	first_name: string | null;
	last_name: string | null;
	company_name: string | null;
	is_company: boolean;
}

export interface InvoiceAllocationDetail {
	allocation_id: number;
	allocation_type: number;
	allocated_amount: number;
	allocation_note: string | null;
	allocation_created_at: string;
	allocation_is_canceled: boolean;
	invoice_id: number;
	invoice_doc_number: string;
	invoice_type: number;
	invoice_value: number;
	invoice_currency: string;
	invoice_date: string;
	invoice_is_canceled: boolean;
	invoice_vat_amount: number | null;
	invoice_effective_tax_rate: number | null;
	recipient_first_name: string | null;
	recipient_last_name: string | null;
	recipient_company_name: string | null;
	recipient_is_company: boolean;
}

export interface PaymentJournalRow {
	payment_id: number;
	payment_value: number;
	payment_currency: string;
	valuta_date: string | null;
	entry_date: string | null;
	payment_type: number;
	payment_note_1: string | null;
	payment_note_2: string | null;
	organization_id: string;
	bank_account_id: number | null;
	payment_created_at: string;
	esr_code: string | null;
	total_allocated_amount: number;
	invoice_count: number;
	invoice_doc_numbers: string | null;
	primary_sender: PrimarySenderInfo | null;
	primary_sender_type: 'patient' | 'guarantor' | 'client' | null;
	primary_client_id: string | null;
	primary_guarantor_id: string | null;
	invoice_allocations: InvoiceAllocationDetail[] | null;
}

export interface InvoiceAllocationSubRow extends InvoiceAllocationDetail {
	payment_id: number;
	isInvoiceSubRow: true;
}

export interface PaymentJournalRowWithSubRows extends PaymentJournalRow {
	isInvoiceSubRow: false;
	subRows?: InvoiceAllocationSubRow[];
}

export type PaymentJournalTableRowData = PaymentJournalRowWithSubRows | InvoiceAllocationSubRow;

export function isPaymentPrimaryRow(row: PaymentJournalTableRowData): row is PaymentJournalRowWithSubRows {
	return !('isInvoiceSubRow' in row) || row.isInvoiceSubRow === false;
}

export function isInvoiceSubRow(row: PaymentJournalTableRowData): row is InvoiceAllocationSubRow {
	return 'isInvoiceSubRow' in row && row.isInvoiceSubRow === true;
}
